import { Image, Text, View } from "@react-pdf/renderer";
import { ratingIcons } from "config/pdfIcons";
import { globalStyles } from "config/pdfStyles";
import { formatString } from "helpers/common";
import { useMemo } from "react";
import RangeSlider from "./RangeSlider";

const ratingOptions = [
  "needs_work",
  "average",
  "good",
  "excellent"
]

const EvaluationRating = ({ rating }) => {
  const rangeValue = useMemo(() => {
    switch(rating){
      case "needs_work":
        return 0;

      case "average":
        return 1;

      case "good":
        return 2;

      case "excellent":
        return 3;

      default:
        return 0;
    }
  }, [rating]);

  return (
    <View>
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        {ratingOptions.map((ratingOption, index) => (
          <View key={index} style={{ alignItems: "center", width: "25%" }}>
            <Image src={ratingIcons[ratingOption]} style={globalStyles.imgIcon} />
            <Text
              style={{
                color: ratingOption === "needs_work" ? "#e24b4b" : "#333"
              }}
            >
              {formatString(ratingOption)}
            </Text>
          </View>
        ))}
      </View>
      <View style={{ marginTop: 5 }}>
        <RangeSlider value={rangeValue} max={3} rating={rating} />
      </View>
    </View>
  )
}

export default EvaluationRating;